import type React from "react";

import JoinOrgGateCustom from "./JoinOrgGateCustom";

const JoinOrgGateWrapper = ({ children }: { children: React.ReactNode }) => {
  return <JoinOrgGateCustom>{children}</JoinOrgGateCustom>;
};

JoinOrgGateWrapper.displayName = "JoinOrgGate";

export default JoinOrgGateWrapper;
